import { WEB_ADVERT_FEATURE_TOGGLE } from "../../constants";
import isEnabled from "../isEnabled";
import getConfigVariable from "./getConfigVariable";

const getFeaturesConfig = async (app, country, featuresPromise, production) => {
  const features = await featuresPromise;

  const featureToggleVariables = features
    .getFeature(WEB_ADVERT_FEATURE_TOGGLE)
    .getVariables();

  const featuresConfig = getConfigVariable(featureToggleVariables, production);

  if (featuresConfig === null) {
    return {
      enableAPICalls: false,
      enableDisplayAdverts: false,
      enableGoogleAdverts: true
    };
  }

  const {
    criteo: { apiCalls, displayAdverts },
    google: { enabled }
  } = featuresConfig;

  const appEnabledApi = isEnabled(app, apiCalls.apps);
  const countryEnabledApi = isEnabled(country, apiCalls.countries);

  const appEnabledDisplayAdverts = isEnabled(app, displayAdverts.apps);
  const countryEnabledDisplayAdverts = isEnabled(
    country,
    displayAdverts.countries
  );

  const enableDisplayAdverts =
    appEnabledDisplayAdverts && countryEnabledDisplayAdverts;

  const enableGoogleAdverts = enabled && !enableDisplayAdverts;

  return {
    enableAPICalls: appEnabledApi && countryEnabledApi,
    enableDisplayAdverts,
    enableGoogleAdverts
  };
};

export default getFeaturesConfig;
